import { RouteConfig } from 'vue-router'
import {
  routerLogin,
  routerHome,
  router401,
  router404,
  router500,
} from '@/router/router_mgr/frame_routes'
// import { UserModule } from '@/store/modules/user'


export function staticRouters(ignoreAccess: boolean): RouteConfig[] {
  // UserModule.localUserInfo()
  const ret: RouteConfig[] = []
  ret.push(routerLogin())
  ret.push(routerHome())
  ret.push(router401())
  ret.push(router404())
  ret.push(router500())

  // const other: RouteConfig[] = getUserRouters(ignoreAccess)
  // ret = ret.concat(other)
  return ret
}

export default staticRouters
